<template>
  <div class="wrapper">
    <!-- <button @click="btnClick()">极验</button> -->
    <!-- isgt是一个布尔值，当前页面点击按钮，修改它，子组件监听数据变化，加载滑动模块 -->
    <Geet :isGeet="isgt" @geetPath="GeetPath" @clickChange="GeetChange"></Geet>
    <div class="topBox"></div>
    <div class="symbolBox">
      <div class="noCodeBox">
        <input
          v-model="loginName"
          @blur="blurInput"
          type="text"
          placeholder="姓名(与有效证件一致)"
        />
        <span class="warnSymbol">*</span>
      </div>
    </div>
<!--     <div class="symbolSelect">
      <select
        class="proSelect"
        label="证件类型"
        v-model="cardSelect"
        @change="cardSelectAction"
      >
        <option value="" disabled selected>证件类型</option>
        <option
          v-for="item in cardList"
          :key="item.index"
          :value="item.value"
          >{{ item.name }}</option
        >
      </select>
      <span class="warnSymbol">*</span>
    </div>
    <div class="symbolBox">
      <div class="idBox">
        <input
          v-model="loginCard"
          @blur="blurInput"
          type="text"
          placeholder="证件号码"
        />
        <span class="warnSymbol">*</span>
      </div>
    </div>
    <p class="warnText">先上传有效证件可以快速补充身份信息</p> -->
    <div class="symbolBox">
      <div class="phoneBox">
        <input
          v-model="loginPhone"
          @blur="blurInput"
          v-bind:disabled="crmPhoneFlag"
          type="text"
          placeholder="请输入手机号码"
        />
        <span class="warnSymbol">*</span>
      </div>
    </div>
    <div class="symbolBox">
      <div class="codeBox">
        <input
          v-model="userWriteForm.loginCode"
          @blur="blurInput"
          type="text"
          placeholder="请输入验证码"
          v-bind:disabled="gatFlag"
        />
        <!-- <span class="getPhoneCode" @click="getPhoneCode">{{ VerShowTxt }}</span> -->
        <span class="getPhoneCode" @click="btnClick">{{ VerShowTxt }}</span>
      </div>
      <span class="warnSymbol">*</span>
    </div>
    <div class="symbolSelect saleChoose">
      <select
        class="proSelect"
        label="置业顾问"
        v-model="proSelect"
        v-bind:disabled="proFlag"
        @change="satusSelect"
        :class="proFlag ? 'proCan':''"
      >
        <option value="-1" disabled selected>您的置业顾问</option>
        <option
          v-for="item in saleList"
          :key="item.index"
          :value="item.saleropenid"
          >{{ item.salername }}</option
        >
      </select>
      <span class="warnSymbol">*</span>
    </div>
<!--     <div style="margin-top: .3rem">
      <div class="upload-title">
        <span class="warnSymbol2">*</span>请拍摄并上传身份证
      </div>
      <div class="upload-layer">
        <div class="left-layer">
          <div class="upimg-layer">
            <hwyupimgcard
              :multiple="multiple"
              id="id"
              :url="url"
              @changeUrl="changeUrl"
              :iconBase64="iconBase64s"
              @changeBase="changeBase"
            ></hwyupimgcard>
            <img :src="upimgsrc" alt v-if="upimgsrc" />
          </div>
          <div class="title-layer">身份证正面照片</div>
        </div>
        <div class="right-layer">
          <div class="upimg-layer u2">
            <hwyupimg
              :multiple="multiple"
              id="id2"
              :url="url2"
              @changeUrl="changeUrl2"
            ></hwyupimg>
            <img :src="upimgsrc2" alt v-if="upimgsrc2" />
          </div>
          <div class="title-layer">身份证背面照片</div>
        </div>
      </div>
    </div>
    <p class="warnText2">请上传本人清晰有效证件正反照片</p>
    <div class="hasPerson">
      <div v-for="(item, index) in addFormList" class="smallHas" :key="index">
        <p @click="chanceThis(item, index)">
          <span>{{ item.name }}</span>
          <span>{{ item.relation }}</span>
          <span>{{ item.mobile }}</span>
        </p>
        <span class="delPerson" @click="detThis(index)"></span>
      </div>
    </div>
    <p class="addPerson" @click="addPerson"></p> -->
    <p class="postBtn" @click="postAll">提交</p>
    <!-- <p class="postBtn" @click="isIdCard">提交</p> -->
    <!-- 添加联名购买人弹窗 -->
    <div class="addBox" v-show="addFlag">
      <div class="smallAdd">
        <p class="closeAdd" @click="closeAdd"></p>
        <p class="addTitle">添加联名购买人</p>
        <div class="symbolBox">
          <div class="noCodeBox">
            <input
              v-model="addForm.name"
              @blur="blurInput"
              type="text"
              placeholder="姓名(与有效证件一致)"
            />
            <span class="warnSymbol">*</span>
          </div>
        </div>
        <div class="symbolSelect">
          <select
            class="proSelect"
            label="证件类型"
            v-model="addForm.idType"
            @change="addFormsatusSelect"
          >
            <option value="" disabled selected>证件类型</option>
            <option
              v-for="item in cardList"
              :key="item.index"
              :value="item.value"
              >{{ item.name }}</option
            >
          </select>
          <span class="warnSymbol">*</span>
        </div>
        <div class="symbolBox">
          <div class="idBox">
            <input
              v-model="addForm.idcard"
              @blur="blurInput"
              type="text"
              placeholder="证件号码"
            />
            <span class="warnSymbol">*</span>
          </div>
          <!-- <div class="seeCard" @click="seeCard">
            <upimgcard
              :multiple="multiple"
              id="idcard2"
              :url="urlcard2"
              :iconBase64="iconBase64s2"
              @changeBase="changeBase2"
            ></upimgcard>
            <img :src="upimgsrccard2" alt v-if="upimgsrccard2" />
          </div> -->
        </div>
        <p class="warnText">先上传有效证件可以快速补充身份信息</p>
        <div class="symbolBox">
          <div class="phoneBox">
            <input
              v-model="addForm.mobile"
              @blur="blurInput"
              type="text"
              placeholder="请输入手机号码"
            />
            <span class="warnSymbol">*</span>
          </div>
        </div>
        <div class="symbolSelect">
          <select
            class="proSelect"
            label="关系"
            v-model="addForm.relation"
            @change="addFormShip"
          >
            <option value="" disabled selected>请选择与主要权益人关系</option>
            <option
              v-for="item in shipList"
              :key="item.index"
              :value="item.value"
              >{{ item.name }}</option
            >
          </select>
          <span class="warnSymbol">*</span>
        </div>
        <div style="margin-top: .3rem">
          <div class="upload-title">
            <span class="warnSymbol2">*</span>请拍摄并上传身份证
          </div>
          <div class="upload-layer">
            <div class="left-layer">
              <div class="upimg-layer">
                <hwyupimgcard
                  :multiple="multiple"
                  id="id3"
                  :url="url3"
                  @changeUrl="changeUrl3"
                  :iconBase64="iconBase64s2"
                  @changeBase="changeBase2"
                ></hwyupimgcard>
                <img :src="addForm.idcardFace" alt v-if="addForm.idcardFace" />
              </div>
              <div class="title-layer">身份证正面照片</div>
            </div>
            <div class="right-layer">
              <div class="upimg-layer u2">
                <hwyupimg
                  :multiple="multiple"
                  id="id4"
                  :url="url4"
                  @changeUrl="changeUrl4"
                ></hwyupimg>
                <img :src="addForm.idcardback" alt v-if="addForm.idcardback" />
              </div>
              <div class="title-layer">身份证背面照片</div>
            </div>
          </div>
        </div>
        <p class="warnText2">请上传本人清晰有效证件正反照片</p>
        <p class="postBtn" @click="postAdd">确认添加</p>
      </div>
      <!-- <p class="closeAdd" @click="closeAdd"></p> -->
    </div>
  </div>
</template>
<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { MessageBox, Field, Indicator } from "mint-ui";
import { mapState } from "vuex";
import wxsdk from "@/utils/wxsdk";
import request from "@/utils/request";
import Cookies from "js-cookie";
import "./components/all.css";
import upimg from "./components/upimg2.vue";
import upimgcard from "./components/upcard.vue";
import newup from "./components/newup.vue";
import Geet from "./components/Geet.vue";
import hwyupimgcard from "./components/hwy-upcard.vue";
import hwyupimg from "./components/hwy-upimg.vue";
export default {
  components: { "mt-field": Field, upimg, upimgcard, newup , Geet , hwyupimg , hwyupimgcard},
  data() {
    return {
      projectid: this.$route.query.pid ? this.$route.query.pid : 2343,
      loginName: "",
      proSelect: "",
      proFlag: false,   // 证件状态是否可选
      cardSelect: "",
      loginCard: "",
      loginPhone: "",
      shareProjectName: "",
      idFlag: false,
      idFlag2: false,
      crmPhoneFlag: false,
      IsCanVer: true, //是否能发送验证码
      userWriteForm:{
        loginCode: "",
      },
      VerShowTxt: "获取验证码",
      VerShowSec: 60, //读秒
      addFlag: false,
      addForm: {
        name: "",
        idType: "",
        idcard: "",
        mobile: "",
        relation: "",
        idcardFace: "", //上传图片
        idcardback: "" //上传图片
      },
      addFormList: [], //联名购买人总表
      chanceAddIndex: 0, //修改联名购买人索引
      chanceFlag: false,
      addMore: [],
      cardList: [
        { name: "身份证", value: 1 },
        { name: "港澳台身份证", value: 2 },
        { name: "营业执照", value: 3 },
        { name: "外籍身份证", value: 4 },
        { name: "军官证", value: 5 },
        { name: "其他", value: 6 }
      ],
      saleList: [],
      shipList: [
        { name: "夫妻", value: "夫妻" },
        { name: "母女", value: "母女" },
        { name: "父子", value: "父子" },
        { name: "父女", value: "父女" },
        { name: "母子", value: "母子" },
        { name: "其他", value: "其他" }
      ],
      //上传图片
      multiple: false,
      id: "upimg",
      url: [],
      upimgsrc: "", //上传图片

      id2: "upimg2",
      url2: [],
      upimgsrc2: "", //上传图片

      id3: "upimg3",
      url3: [],

      id4: "upimg4",
      url4: [],

      idcard: "upimgsrccard",
      urlcard: [],
      upimgsrccard: "", //上传身份证识别
      iconBase64s: "",

      idcard2: "upimgsrccard2",
      urlcard2: [],
      upimgsrccard2: "", //上传身份证识别
      iconBase64s2: "",
      referenceOpenid: this.$route.query.referenceOpenid
        ? this.$route.query.referenceOpenid
        : "",
      isgt: false,
      isGAT: false, //港澳台手机号
      gatFlag: false //港澳台手机号点击事件
    };
  },
  computed: {
    ...mapState([
      "isInMiniProgram",
      "pageInfo",
      "userInfo",
      "shareSpreadInfo",
      "receiveSpreadInfo",
      "rsCardInfo",
      "isShowGuide"
    ]),
  },
  watch: {
    url: {
      handler(val) {
        this.upimgsrc = val[val.length - 1];
      }
    },
    url2: {
      handler(val) {
        this.upimgsrc2 = val[val.length - 1];
      }
    },
    url3: {
      handler(val) {
        this.addForm.idcardFace = val[val.length - 1];
      }
    },
    url4: {
      handler(val) {
        this.addForm.idcardback = val[val.length - 1];
      }
    },
    userWriteForm: {
      handler() {
        if (this.userWriteForm.loginCode.length > 4) {
          this.userWriteForm.loginCode = this.userWriteForm.loginCode.substring(0, 6);
        }
      },
      deep: true
    }
  },
  filters: {},
  methods: {
    btnClick() {
      console.log("2,按钮被点击，进行图形验证");
      if(this.loginPhone.length <= 0){
        MessageBox.alert("请输入正确的手机号！","提示");
      }else{
        this.isgt = !this.isgt;
      }
    },
    // 极验图片加载之后，通过更改控制变量实现可以再次加载
    GeetChange(val) {
      this.isgt = val;
    },
    GeetPath(val) {
      let that = this;
      console.log("4,接受到图形验证参数，将参数发往服务端进行验证");
      console.log(val);
      that.axios
        .get(
          "http://qmyx.rushiai.com/qc-webapp/openApi/secondValid?openid=" +
            that.$openid +"&challenge=" + val.geetest_challenge + "&validate=" + val.geetest_validate +
           "&seccode=" + val.geetest_seccode
        )
        .then(res => {
          console.log(res)
          if(res.code == 0){
            if(util.isMobile(that.loginPhone)){
              that.gatFlag = false
              that.getPhoneCode();
              that.byPhoneSale();
            }else if(util.isGATMobile(that.loginPhone)){
              console.log('这是一个港澳台用户')
              MessageBox.alert("港澳台手机号暂时无需输入验证码，请继续注册流程","提示");
              // that.isGAT = true;
              that.gatFlag = true
              // that.userWriteForm.loginCode = 'yq@hf'
            }else{
              MessageBox.alert("请输入正确的手机号！","提示");
            }
          }else{
            MessageBox.alert("当前网络验证延迟，请稍后再试","提示");
          }
        })
      this.isgt = false;
    },
    // 获取配置i信息
    getConfig() {
      let that = this;
      request
        .get(that.global.API_URL, {
          action: "/house/HouseOnlineAction/getConfig",
          requestParam: { projectId: that.projectid }
        }).then(function(data) {
          console.log(data.obj);
          that.shareProjectName = data.obj.name;
          that.shareInit();
        })
    },
    //上传图片
    changeUrl(urls) {
      this.url = urls;
    },
    changeUrl2(urls) {
      this.url2 = urls;
    },
    changeUrl3(urls) {
      this.url3 = urls;
    },
    changeUrl4(urls) {
      this.url4 = urls;
    },
    changeBase(data) {
      let that = this;
      if (that.loginCard != "" || that.cardSelect != 1) {
        return;
      }
      console.log(data);
      Indicator.open({
        text: "身份证识别中...",
        spinnerType: "fading-circle"
      });

      if (data) {
        request
          .post2(that.global.API_URL, {
            j: JSON.stringify({
              openid: that.$openid || "",
              passport: that.$passport || "",
              vericode: "",
              url: location.href,
              headers: {
                "Content-Type":
                  "application/x-www-form-urlencoded; charset=UTF-8"
              },
              action: "/house/HouseOnlineAction/idCardOcr",
              requestParam: {
                imageBase64: data,
                side: "front"
              }
            })
          })
          .then(response => {
            console.log(response);
            Indicator.close();
            let userCard = JSON.parse(response.obj);
            if (userCard.words_result["公民身份号码"].words != "") {
              console.log(userCard.words_result["公民身份号码"].words);
              that.loginCard = userCard.words_result["公民身份号码"].words;
            } else {
              MessageBox.alert(
                "暂只支持识别身份证正面照或该证件照不清晰请您手动填写身份证号以保证后续购房流程的完整性",
                "提示"
              );
            }
          });
      }
    },
    changeBase2(data) {
      console.log(data);
      let that = this;
      if (that.addForm.idcard != "" || that.addForm.idType != 1) {
        return;
      }
      Indicator.open({
        text: "身份证识别中...",
        spinnerType: "fading-circle"
      });
      if (data) {
        request
          .post2(that.global.API_URL, {
            j: JSON.stringify({
              openid: that.$openid || "",
              passport: that.$passport || "",
              vericode: "",
              url: location.href,
              headers: {
                "Content-Type":
                  "application/x-www-form-urlencoded; charset=UTF-8"
              },
              action: "/house/HouseOnlineAction/idCardOcr",
              requestParam: {
                imageBase64: data,
                side: "front"
              }
            })
          })
          .then(response => {
            console.log(response);
            Indicator.close();
            let userCard = JSON.parse(response.obj);
            if (userCard.words_result["公民身份号码"].words != "") {
              console.log(userCard.words_result["公民身份号码"].words);
              that.addForm.idcard = userCard.words_result["公民身份号码"].words;
            } else {
              MessageBox.alert("暂只支持识别身份证正面照", "提示");
            }
          });
      }
    },
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight == windowFocusHeight) {
        return;
      }
      console.log(this.windowHeight + "--" + windowFocusHeight);
      console.log("修复");
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    },
    blurInput() {
      let that = this;
      that.temporaryRepair();
    },
    testAll(){
      let that = this;
      request
        .get(that.global.API_URL, {
          action: "/dhyx/DhProjectSalespersonAction/getSalespersonByManagerUserKey",
          requestParam: { projectId: that.projectid }
        })
        .then(function(data) {
          console.log(data)
        })
    },
    // 获取销售列表
    getSalesperson() {
      let that = this;
      request
        .get(that.global.API_URL, {
          // action: "/dhyx/DhProjectSalespersonAction/getSalespersonList",
          action: "/dhyx/DhProjectSalespersonAction/getSalespersonByManagerUserKey",
          requestParam: { projectId: that.projectid }
        })
        .then(function(data) {
          console.log(data.obj);
          console.log(data.obj.list[0].saleropenid);
          if (data.obj.total <= 0) {
            MessageBox.alert("当前项目暂未配置销售人员");
          } else {
            let saleFirst = data.obj.list;
            let saleTwo = [];
            let reSale = [];
            // 是否有上级销售分享
            if (that.referenceOpenid == "") {
              saleFirst.forEach(item => {
                console.log(item.roleid);
                if (item.roleid == 2011 && item.pad_reception != 1) {
                  reSale.push(item);
                }
              });
              // that.saleList = data.obj.list;
              that.saleList = reSale;
              that.proSelect = "-1";
            } else {
              saleFirst.forEach(item => {
                if (
                  item.saleropenid == that.referenceOpenid &&
                  item.roleid == 2011 &&
                  item.pad_reception != 1
                ) {
                  reSale.push(item);
                }
              });
              saleFirst.forEach(item => {
                if (
                  item.saleropenid != that.referenceOpenid &&
                  item.roleid == 2011 &&
                  item.pad_reception != 1
                ) {
                  saleTwo.push(item);
                }
              });
              that.saleList = reSale.concat(saleTwo);
              if (that.saleList[0].saleropenid == that.referenceOpenid) {
                that.proSelect = that.saleList[0].saleropenid;
              } else {
                that.proSelect = "-1";
              }
            }
          }
        });
    },
    satusSelect() {
      let that = this;
      console.log(that.proSelect);
    },
    cardSelectAction() {
      let that = this;
      console.log(that.cardSelect);
    },
    addFormsatusSelect() {
      let that = this;
      console.log(that.addForm.idType);
    },
    addFormShip() {
      let that = this;
      console.log(that.addForm.relation);
    },
    // 识别身份证点击事件
    seeCard() {
      let that = this;
      console.log(123456);
    },
    // 获取验证码
    getPhoneCode() {
      let that = this;
      if(that.gatFlag){
        MessageBox.alert("港澳台手机号暂时无需输入验证码，请继续注册流程");
        return
      }
      console.log(that.loginPhone);
      if (that.IsCanVer) {
        let phone = that.loginPhone;
        if (phone.length == 0) {
          MessageBox.alert("请输入手机号！");
        } else if (!util.isMobile(phone)) {
          MessageBox.alert("请输入正确的手机号！");
        } else {
          that.IsCanVer = false;
          that.VerShowTxt = that.VerShowSec + "s";
          that.VerShowSec--;
          setInterval(function() {
            if (that.IsCanVer == false) {
              if (that.VerShowSec == 0) {
                that.VerShowTxt = "获取验证码";
                that.IsCanVer = true;
                that.VerShowSec = 60;
              } else {
                that.VerShowTxt = that.VerShowSec + "s";
                that.VerShowSec--;
              }
            }
          }, 1000);
          that.getSmsCode();
        }
      }
    },
    // 获取验证码getVericode
    getSmsCode() {
      let that = this;
      return new Promise(function(resolve, reject) {
        request
          .get(that.global.API_URL, {
            action: "/house/HouseOnlineAction/sendMobileCode",
            requestParam: {
              projectId: that.projectid,
              mobile: that.loginPhone
            }
          })
          .then(function(data) {
            console.log(data);
            if (data.code != 0) {
              MessageBox.alert(data.obj);
            } else {
              resolve(data);
              console.log('早要跑')
              if(!that.proFlag){
                that.byPhoneSale()
              }
            }
          });
      });
    },
    // 打开添加联名购买人弹窗
    addPerson() {
      let that = this;
      console.log(that.addFormList);
      that.detData();
      that.addFlag = true;
    },
    // 清除联名购买人弹窗数据
    detData() {
      let that = this;
      that.addForm.name = "";
      that.addForm.idType = "";
      that.addForm.idcard = "";
      that.addForm.mobile = "";
      that.addForm.relation = "";
      that.addForm.idcardFace = "";
      that.addForm.idcardback = "";
    },
    // 关闭联名购买人弹窗
    closeAdd() {
      let that = this;
      if (that.chanceFlag) {
        that.addFlag = false;
        that.chanceFlag = false;
      } else {
        that.detData();
        that.addFlag = false;
      }
    },
    // 确认联名购买人
    postAdd() {
      let that = this;
      that.isIdCard(2)
      if (that.addForm.name == "") {
        MessageBox.alert("请填写联名购买者姓名", "提示");
      } else if (that.addForm.idType == "") {
        MessageBox.alert("请选择证件类型", "提示");
      } else if (!that.idFlag2) {
        MessageBox.alert("请填写正确的证件号码", "提示");
      } else if (!util.isMobile(that.addForm.mobile)) {
        MessageBox.alert("请填写正确的手机号码", "提示");
      } else if (that.addForm.relation == "") {
        MessageBox.alert("请确认关系", "提示");
      } else if (
        that.addForm.idcardFace == "" ||
        that.addForm.idcardback == ""
      ) {
        MessageBox.alert("请保证已上传联名购买人的身份证正反面", "提示");
      } else {
        // that.addForm["idcardFace"] = that.idcardFace;
        // that.addForm["idcardback"] = that.idcardback;
        that.addForm["projectId"] = that.projectid;
        that.addForm["salesperson"] = that.proSelect;
        let pushData = Object.assign(
          {},
          JSON.parse(JSON.stringify(that.addForm))
        );
        // 判断是修改还是新增
        if (that.chanceFlag) {
          that.addFormList[that.chanceAddIndex] = pushData;
          that.addFlag = false;
          that.chanceFlag = false;
        } else {
          that.addFormList.push(pushData);
          that.addFlag = false;
        }
        that.addFlag = false;
      }
      console.log(that.addFormList);
    },
    // 删除联名购买人
    detThis(index) {
      let that = this;
      console.log(index);
      that.addFormList.splice(index, 1);
    },
    // 修改联名购买人
    chanceThis(item, index) {
      let that = this;
      that.chanceFlag = true;
      console.log(that.addFormList[index]);
      that.chanceAddIndex = index;
      that.addForm = item;
      that.addFlag = true;
    },
    // 验证身份证、港澳台身份证
    isIdCard(num){
      let that = this;
      // num为1的时候,是验证主注册人   2是验证联名购买人
      if(num == 1){
        if(that.cardSelect == 1){
          console.log(util.idCardValid(that.loginCard))
          if(util.idCardValid(that.loginCard)){
            that.idFlag = true
          }else{
            that.idFlag = false
          }
        }else if(that.cardSelect == 2){
          console.log(util.isHKCard(that.loginCard))
          if(util.isHKCard(that.loginCard)){
            that.idFlag = true
          }else{
            that.idFlag = false
          }
        }else{
          if(that.loginCard == ""){
            that.idFlag = false
          }else{
            that.idFlag = true
          }
        }
      }else{
        if(that.addForm.idType == 1){
          console.log(util.idCardValid(that.addForm.idcard))
          if(util.idCardValid(that.addForm.idcard)){
            that.idFlag2 = true
          }else{
            that.idFlag2 = false
          }
        }else if(that.addForm.idType == 2){
          console.log(util.isHKCard(that.addForm.idcard))
          if(util.isHKCard(that.addForm.idcard)){
            that.idFlag2 = true
          }else{
            that.idFlag2 = false
          }
        }else{
          if(that.addForm.idcard == ""){
            that.idFlag2 = false
          }else{
            that.idFlag2 = true
          }
        }
      }

    },
    // 提交信息
    postAll() {
      let that = this;
      that.isIdCard(1)
      console.log(that.userWriteForm.loginCode)
      let mainUser = {
        projectId: that.projectid,
        salesperson: that.proSelect,
        name: that.loginName,
        // idType: that.cardSelect,
        // idcard: that.loginCard,
        mobile: that.loginPhone,
        // idcardFace: that.upimgsrc,
        // idcardback: that.upimgsrc2
      };
      console.log(mainUser);
      if (that.loginName == "") {
        MessageBox.alert("请填写您的姓名", "提示");
      // } else if (that.cardSelect == "") {
      //   MessageBox.alert("请选择证件类型", "提示");
      // } else if (!that.idFlag) {
      //   MessageBox.alert("请填写正确的证件号码", "提示");
      } else if (that.proSelect == -1) {
        MessageBox.alert("请选择置业顾问", "提示");
      } else if (that.loginPhone.length <= 0) {
        MessageBox.alert("请填写正确的手机号码", "提示");
      // } else if (that.upimgsrc == "" || that.upimgsrc2 == "") {
      //   MessageBox.alert("请保证已上传您的证件正反面照片", "提示");
      } else {
        if(that.gatFlag){
          Cookies.set("vericode", 'yq@hf');
        }else{
          Cookies.set("vericode", that.userWriteForm.loginCode);
        }
        request
          .get(
            `${that.global.API_URL}`,
            {
              action: "/house/HouseOnlineAction/registerV2",
              requestParam: {
                mainUser: mainUser,
                relationUsers: that.addFormList
              }
            },
            {
              mask: true
            }
          )
          .then(response => {
            console.log(response);
            if (response.code == 0) {
              MessageBox.alert("注册成功", "提示").then(() => {
                that.$router.push("housePage?pid=" + that.projectid);
              })
            } else {
              MessageBox.alert(response.errmsg);
            }
          });
      }
    },
    crmPhone() {
      let that = this;
      request
        .get(that.global.API_URL, {
          action: "/dhyx/DhProjectSalespersonAction/getSPUserInfoByOpenid",
          requestParam: { projectId: that.projectid }
        })
        .then(function(data) {
          console.log(data.obj);
          if (data.obj != "") {
            that.loginPhone = data.obj.mobile;
            that.crmPhoneFlag = true;
            that.byPhoneSale()
          } else {
            that.crmPhoneFlag = false;
          }
        });
    },
    // 新增验证手机号固定销售
    byPhoneSale(){
      let that = this;
      let saleNum = 0
      console.log(11111)
      request
        .get(that.global.API_URL, {
          action: "/dhyx/DhProjectSalespersonAction/getSPUserInfoByMobile",
          requestParam: { 
            projectId: that.projectid,
            mobile: that.loginPhone
          }
        })
        .then(function(data) {
          console.log(data.obj);
          // console.log(that.saleList)
          that.saleList.forEach(item =>{
            // console.log(item.saleropenid)
            if(item.saleropenid == data.obj.saleropenid){
              saleNum++
            }
          })
          console.log(saleNum)
          if(saleNum == 0){
            that.proSelect = -1
          }else{
            that.proSelect = data.obj.saleropenid;
            that.proFlag = true
          }
        });
    },
    shareInit(){
      let that = this;
      //设置分享
      that.global.SHARE_TITLE = `${that.shareProjectName}售楼中心，线上看房，实时咨询，欢迎您的光临！`;
      that.global.SHARE_DESC = `美好人居，一触即达。帮忙传播，更有多重惊喜哟！`;
      that.global.SHARE_IMG_URL =
        "http://assets.rurushishi.com/yq-rs-make/huafasubscription/hfrgShare.jpg";
      let shareLink = `${location.protocol}//${location.host}/h5/huafasubscription/housePage?pid=${this.projectid}&refereeopenid=${
        this.shareSpreadInfo.refereeopenid
      }`;
      console.log(shareLink)
      that.global.SHARE_LINK = shareLink;
      wxsdk.init();
    }
  },
  mounted() {
    this.getConfig();
    this.getSalesperson();
    this.crmPhone();
    this.testAll()
  }
};
</script>
<style lang="stylus" scoped>
.wrapper {
  background-color: #FFFFFF;
}
.topBox{
  width 100%
  height 1.96rem
  background url('https://assets.rurushishi.com/yq-rs-make/huafasubscription/ttop1.png') no-repeat center
  background-size 6.7rem .84rem
  border-bottom .2rem solid #FAFAFA
}
.proSelect {
  width 100%
  min-height 48px
  margin 0 auto
  display block
  appearance none
  -moz-appearance none
  -webkit-appearance none
  background url('http://assets.rurushishi.com/activies/hdbH5/selectBottom.png') no-repeat scroll right center transparent
  background-size 0.4rem 0.4rem
  font-family PingFangSC-Regular
  color #646c7f
  border-bottom 2px solid #EEEEF0 !important
  text-indent .1rem
  margin-top .3rem
  line-height 1
  text-indent 1rem
  font-size .28rem
}
.proCan{
  background-color rgb(235, 235, 228)
}
.symbolBox,.symbolSelect{
  position relative
  width 90%
  margin 0 auto
}
.symbolSelect{
  background url('https://assets.rurushishi.com/yq-rs-make/huafasubscription/loginId.png') no-repeat 10px center
  background-size .34rem
}
.saleChoose{
  background none
}
.saleChoose .proSelect{
  text-indent .5rem
}
.saleChoose .warnSymbol{
  left .2rem
}
.warnSymbol{
  position absolute
  left 0.6rem
  font-size .4rem
  top .3rem
  color #f00
}
.warnSymbol2{
  position absolute
  left -.2rem
  font-size .4rem
  top .4rem
  color #f00
  line-height 0
}
.warnText{
  width 90%
  margin 0 auto
  color #E6002D
  font-size .2rem
  line-height .4rem
}
.warnText2{
  width 100%
  line-height .54rem
  color #E6002D
  text-align center
  font-size .22rem
}
.seeCard{
  position absolute
  top .3rem
  right 0
  width .32rem
  height .32rem
  background url('https://assets.rurushishi.com/yq-rs-make/huafasubscription/seeCard.png') no-repeat center
  background-size 100% 100%
}
.codeBox,.noCodeBox,.idBox,.phoneBox{
  width 100%
  border-bottom 2px solid rgba(238,238,240,1) !important
  margin .1rem auto !important
  background-image none
  line-height 1rem !important
  text-indent .5rem
  background  url('http://assets.rurushishi.com/activies/zxrc/code.png') no-repeat 10px center
  background-size .34rem
  color white
  min-height 48px
  line-height 1
  padding-left 1rem
  box-sizing border-box
  display flex
  justify-content space-between
  font-size .28rem
  margin-top .3rem !important
  font-family PingFangSC-Regular
}
.noCodeBox{
  background url(http://assets.rurushishi.com/activies/hdbH5/loginName.png) no-repeat 10px center
  background-size .34rem
  text-indent 0
  line-height 1 !important
}
.idBox{
  background url(https://assets.rurushishi.com/yq-rs-make/huafasubscription/loginCard.png) no-repeat 10px center
  background-size .34rem
  text-indent 0
  line-height 1 !important
}
.phoneBox{
  background url(http://assets.rurushishi.com/activies/hdbH5/loginPhone.png) no-repeat 10px center
  background-size .34rem
  text-indent 0
  line-height 1 !important
}
.getPhoneCode {
  background #E6002D
  display block
  width 2rem
  height 0.65rem
  border-radius 4px
  text-align center
  font-size 0.25rem
  line-height 0.65rem
  color white
  text-indent 0
  margin-top 6px
}
.codeBox input{
  width 3rem
}
.noCodeBox input,.idBox input,.phoneBox input{
  width 100%
}
.smallHas{
  width 6.36rem
  height .88rem
  margin 0 auto
  border 1px solid #B5B5B5
  border-radius 5px
  line-height .88rem
  margin-bottom .2rem
}
.smallHas p{
  width 5.8rem
  display flex
  justify-content space-around
  float left
}
.delPerson{
  width .34rem
  height .34rem
  margin-top .27rem
  margin-right .12rem
  float right
  background: url('https://assets.rurushishi.com/yq-rs-make/huafasubscription/shanchu.png') no-repeat center
  background-size: 100% 100%
}
.addPerson{
  width 100%
  height .64rem
  background: url('https://assets.rurushishi.com/yq-rs-make/huafasubscription/addPerson.png') no-repeat center
  background-size: 100% 100%
  margin .2rem 0
}
.postBtn{
  background #E6002D
  width 6.36rem
  height 0.8rem
  line-height .8rem
  text-align center
  color white
  margin .3rem auto
  font-size .36rem
  border-radius 10px
}
.addBox{
  width 100%
  height 100%
  overflow auto
  background rgba(0,0,0,.8)
  position fixed
  left 0
  top 0
  z-index 100
}
.smallAdd{
  width 6.7rem
  background white
  margin 1rem auto
  padding .37rem 0 .3rem 0
  border-radius 10px
  position relative
}
.addTitle{
  width 100%
  font-size .3rem
  color #333333
  text-align center
  font-weight bold
}
.closeAdd{
  width .28rem
  height .28rem
  background: url('https://assets.rurushishi.com/yq-rs-make/huafasubscription/close2.jpg') no-repeat center
  background-size: 100% 100%
  position absolute
  right .2rem
  top .2rem
}
.upload-layer {
  display: flex;
  width: 90%;
  margin: 0 auto;
}
.upload-title {
  line-height: .7rem;
  color: #333333;
  font-size: .28rem;
  width: 90%;
  margin: 0 auto;
  position:relative;
  text-indent:.4rem
}
.upload-layer .left-layer{
  flex: 1;
}
.upload-layer .right-layer{
  flex: 1;
}
.upload-layer .title-layer {
  line-height: .8rem;
  font-size: .24rem;
  color: #999999;
  text-align: center
}
.upload-layer .upimg-layer {
  position: relative;
  width: 2.7rem;
  height: 1.69rem;
  background: url('https://assets.rurushishi.com/yq-rs-make/huafasubscription/card1.png') no-repeat left center;
  background-size: 2.7rem 1.69rem;
  margin: 0 auto;
}
.upload-layer .upimg-layer.u2 {
  background: url('https://assets.rurushishi.com/yq-rs-make/huafasubscription/card2.png') no-repeat left center;
  background-size: 2.7rem 1.69rem;
}
.upload-layer .upimg-layer > img {
  display: block;
  width: 2.7rem;
  height: 1.69rem;
}
.mint-indicator{
  z-index 999
}
</style>
